// src/components/Logout.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../api/authApiCall';

const Logout = () => {
    const navigate = useNavigate();
    const history = useNavigate();

    useEffect(() => {
        // Perform logout
        localStorage.removeItem('isAuthenticated');
        logout();
        // Redirect to login page
        navigate('/login');
    }, [navigate]);

    return null;
};

export default Logout;
